import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useStudio } from '../../contexts/StudioContext';
import { duration, euro } from '../../utils/format';
export function WhatWeDo() {
  const {
    services
  } = useStudio();
  return <section id="services" className="mx-auto max-w-shell px-5 py-16 sm:px-6 lg:px-10 lg:py-28" data-id="element-642" data-mp="2tpi26i0wzsn7">
      <Reveal className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between" data-id="element-643" data-mp="3hfkr4p9j8ihl">
        <div className="max-w-xl" data-id="element-644" data-mp="3mf77v8okkgv5">
          <span className="flex items-center gap-3" data-id="element-645" data-mp="3mefdu2amer6z">
            <span className="hairline h-px w-10" aria-hidden="true" data-id="element-646" data-mp="38fpd8cole9dv" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-647" data-mp="38hiknu714xmx">Wat wij doen</span>
          </span>
          <h2 className="mt-5 font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-chalk sm:text-4xl" data-id="element-648" data-mp="1x093jebdihos">
            Drie behandelingen. Geen opvulling.
          </h2>
        </div>
        <Link to="/services" className="inline-flex items-center gap-1.5 text-sm text-dim transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-649" data-mp="3kango3n9x09b">
          Bekijk wat erbij zit
          <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-650" data-mp="3tc3i3lw41s1e" />
        </Link>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-3" data-id="element-651" data-mp="3p9gvbzeaqxb2">
        {services.filter(s => s.active).map((service, i) => <Reveal key={service.id} delay={i * 0.06} data-id="element-652" data-mp="72aleoiiqnlv" data-mpi={i}>
            <Link to="/book" state={{
          serviceId: service.id
        }} className="group relative isolate flex h-full min-h-[420px] flex-col justify-end overflow-hidden rounded-2xl border border-edge transition-colors duration-200 ease-smooth hover:border-ember/60 lg:min-h-[500px]" data-id="element-653" data-mp="2629rl3j5cjg">
              <img src={service.image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-65 transition-[transform,opacity] duration-300 ease-smooth group-hover:scale-[1.04] group-hover:opacity-85" data-id="element-654" data-mp="pv4skw9whbfj" />
              <div className="absolute inset-0 bg-[linear-gradient(to_top,#08090a_14%,rgba(8,9,10,0.2)_72%)]" aria-hidden="true" data-id="element-655" data-mp="3jkqkcxxr81lv" />
              <div className="card-sheen absolute inset-0" aria-hidden="true" data-id="element-656" data-mp="3sgpukr8igx3d" />

              <div className="relative p-6 lg:p-7" data-id="element-657" data-mp="17skss4vjas8">
                <span className="font-display text-xs font-bold tracking-[0.2em] text-ember" data-id="element-658" data-mp="67yeseym99dh">0{i + 1}</span>
                <h3 className="mt-3 font-display text-2xl font-extrabold leading-tight tracking-tightest text-chalk" data-id="element-659" data-mp="b7azat20m4cw">
                  {service.name}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-chalk/70" data-id="element-660" data-mp="f6ipotxxqer5">{service.summary}</p>

                <div className="mt-6 flex items-center justify-between gap-4 border-t border-chalk/15 pt-5" data-id="element-661" data-mp="2d0hc10qc12ij">
                  <span data-id="element-662" data-mp="2h1t3zcwohztw">
                    <span className="block font-display text-xl font-extrabold tracking-tight text-chalk" data-id="element-663" data-mp="29g76spvqgwjv">
                      vanaf {euro(service.price)}
                    </span>
                    <span className="mt-1 block text-[11px] uppercase tracking-[0.14em] text-dim" data-id="element-664" data-mp="1zqnl7cgmyolb">
                      {duration(service.durationMinutes)}
                    </span>
                  </span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-chalk/25 text-chalk transition-colors duration-200 ease-smooth group-hover:border-ember group-hover:bg-ember group-hover:text-void" data-id="element-665" data-mp="2sf2xvscaouth">
                    <ArrowUpRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-666" data-mp="2jdbrsmduelz3" />
                  </span>
                </div>
              </div>
            </Link>
          </Reveal>)}
      </div>
    </section>;
}